export * from "./BsRegSettings";
